export var offeringPageJs = {
    searchSubOfferingData: function (element, offering) {
        var $spinner = $("#spinnerSearch");
        if ($spinner) {
            $spinner.show();
        }

        var linksSuboffering = document.getElementsByClassName('link-suboffering-page active');
        for (var i = 0; i < linksSuboffering.length; i++) {
            var subofferingLink = linksSuboffering[i];
            if (subofferingLink.innerHTML) {
                var innerHTML = subofferingLink.innerHTML;
                subofferingLink.innerHTML = offeringPageJs.removeNumbersInBrackets(innerHTML);
            }
            subofferingLink.classList.remove('active');
        }

        element.classList.add('active');

        var query = "";
        if (offering != '' && typeof offering != "undefined") {
            query += "?s=" + offering;
        }

        if (offeringPageOptions && offeringPageOptions.subOfferingCompaniesUrl) {
            $.ajax({
                url: offeringPageOptions.subOfferingCompaniesUrl + query,
                type: 'POST'
            })
                .done(function (data) {
                    $("#sub-offering-companies").html(data);

                    var $data = $(data); // Convert data to jQuery object
                    var $countElement = $(element).find('.offering-count');

                    $('.offering-count').text('');
                    $countElement.text('(' + $data.find('#offering-page-companies-count').val() + ')');

                    // Use dynamic import to get shortlist and autocomplete bindings because add to shortlist was called twice in offering page because of top level import.
                    // See more about dynamic import in MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/import

                // Bind the shortlist again in order to activate add to shortlist and remove shortlist buttons.
                // When pressing the sub offering buttons on the left side of offering page.
                import("../shortList/shortListPage.js")
                    .then((moduleShortList) => {
                        moduleShortList.shortListPageJs.bindShortList();
                    })
                    .catch((err) => {
                        console.error("offering page error importing dynamic module shortListPage.js. error message: ", err);
                    });

                    // bind / reactivate the custom company search autocomplete.
                    import("./companySearchAutoComplete.js")
                        .then((moduleAutoComplete) => {
                            moduleAutoComplete.customCompanySearchAutoComplete();
                        })
                        .catch((er) => {
                            console.error("offering page error importing dynamic module companySearchAutoComplete.js. error message: ", er);
                        });
                })
                .fail(function (error) {
                    console.error('Error:', error);
                    if ($spinner) {
                        $spinner.hide();
                    }
                });
        }
        if (offeringPageOptions && offeringPageOptions.subOfferingDataUrl) {
            $.ajax({
                url: offeringPageOptions.subOfferingDataUrl + query,
                type: 'POST'
            })
                .done(function (data) {
                    $("#sub-offering-data").html(data);
                })
                .fail(function (error) {
                    console.error('Error:', error);

                    if ($spinner) {
                        $spinner.hide();
                    }
                });
        }
    },
    removeNumbersInBrackets: function (inputString) {
        return inputString.replace(/\(\d+\)/g, '');
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var links = document.getElementsByClassName('link-suboffering-page');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default action (in this case, auto scroll to top)            
        });
    }
});